/**
 * Return a reference to a path in the graph
 * @param {string} path - the target path of the reference
 * @returns {{$type: string, value: *}} - the reference
 */
function ref(path) {
  if (!path || (typeof path !== 'string')) { throw new Error(`Invalid reference: ${path}`); }
  return { $type: 'ref', value: path };
}

module.exports = ref;
